import gql from 'graphql-tag'

export default object => {
	return {
		mutation: gql`
			mutation ($object: pdf_fields_insert_input!) {
				insert_pdf_fields_one(object: $object) {
					id
				}
			}
		`,
		variables: {
			object: {
				db_field_name: object.fieldName,
				db_table_name: object.tableName,
				field_name: object.name,
				field_variable: object.variable
			}
		}
	}
}
